import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
export default function MenuExample() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (_jsxs("div", { children: [_jsx(Button, Object.assign({ "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: handleClick }, { children: "Open Menu" })), _jsxs(Menu, Object.assign({ id: "simple-menu", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, { children: [_jsx(MenuItem, Object.assign({ onClick: handleClose }, { children: "Profile" })), _jsx(MenuItem, Object.assign({ onClick: handleClose }, { children: "My account" })), _jsx(MenuItem, Object.assign({ onClick: handleClose }, { children: "Logout" }))] }))] }));
}
